const quickEntries = ['放大', '细节', '同款', '背景', '反光'];

const heroStats = [
  { label: '本期条目', value: '48' },
  { label: '细节档案', value: '312' },
  { label: '反光点位', value: '57' },
];

export default function HeroCover() {
  return (
    <section id="top" className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-10 pb-12 md:pt-16 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5 rise-in">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-[11px] tracking-[0.3em] text-primary-600 font-medium">VOL.07</span>
              <span className="w-8 h-px bg-background-300"></span>
              <span className="text-[11px] tracking-[0.2em] text-foreground-500">封面特辑</span>
            </div>

            <h2 className="font-heading text-3xl md:text-5xl font-black leading-[1.15] text-foreground-950 mb-5">
              私拍吃瓜放大之后，
              <br />
              细节才刚开始说话
            </h2>

            <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-8 max-w-xl">
              想逐帧确认细节的人，会在这里找到对照。截图与对应片段并排放，翻反光、扒同款、查背景，
              都能从入口直接对上，省事。
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <a
                href="#entry"
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-zoom-in-line"></i>
                </span>
                进入放大入口
              </a>
              <a
                href="#grid"
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-foreground-400 hover:bg-background-100 transition-colors cursor-pointer"
              >
                看本期更新
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-line"></i>
                </span>
              </a>
            </div>

            <div className="flex items-center gap-8 border-t border-background-200 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-2xl font-bold text-foreground-950 leading-none">
                    {stat.value}
                  </div>
                  <div className="mt-1.5 text-[11px] tracking-wider text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 rise-in">
            <div className="relative w-full">
              <div className="absolute -top-3 -left-3 w-16 h-16 border-t-2 border-l-2 border-accent-500"></div>
              <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-2 border-r-2 border-accent-500"></div>

              <div className="relative w-full h-[420px] md:h-[560px] rounded-lg overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20magazine%20cover%20still%20life%20with%20stacked%20instant%20photos%2C%20a%20brass%20magnifying%20glass%20and%20warm%20amber%20light%20on%20a%20cream%20paper%20background%2C%20high%20contrast%20shadows%2C%20cinematic%20minimal%20composition%2C%20rich%20detail&width=1000&height=1300&seq=spcg-hero-cover&orientation=portrait"
                  alt="私拍吃瓜放大 封面图"
                  title="私拍吃瓜放大 细节封面"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-0 left-0 px-4 py-2 bg-primary-500 text-background-50 text-xs tracking-widest">
                  封面
                </div>
                <div className="absolute bottom-0 right-0 px-4 py-3 bg-background-950/70 text-background-50 text-xs tracking-wider backdrop-blur-sm">
                  放大倍率 6.2x · 逐帧可查
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 flex flex-wrap items-center gap-3">
          <span className="text-xs tracking-widest text-foreground-500 mr-1">快速入口</span>
          {quickEntries.map((entry) => (
            <a
              key={entry}
              href="#entry"
              className="px-4 py-2 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
            >
              {entry}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}